/* eslint-disable max-len */
import {
    useCallback,
    useMemo,
} from 'react'
import {
    GridColumnVisibilityModel,
} from '@mui/x-data-grid-pro'

import {
    hideHiddenColumnsForFilter,
} from '../../utils/FilterModel.utils'
import {
    ExtendedGridColDef,
    SkyDataGridLocalStorage,
} from '../../SkyBaseDataGrid.types'
import useSkyDataGridLocalStorage from '../useSkyDataGridLocalStorage'

type Props = {
    columns: ExtendedGridColDef[],
    persistentKey: string,
}

const defaultSetStateConverter = (value: GridColumnVisibilityModel): SkyDataGridLocalStorage => {
    return {
        visibilityModel: {
            ...value,
        },
    }
}

const usePersistedVisibleColumns = ({
    columns,
    persistentKey,
}: Readonly<Props>): [GridColumnVisibilityModel, (model: GridColumnVisibilityModel) => void] => {
    const initialVisibilityModel = useMemo(() => {
        return hideHiddenColumnsForFilter(columns)
    }, [columns])
    const localStorageInitState = useMemo(() => {
        return defaultSetStateConverter(initialVisibilityModel)
    }, [initialVisibilityModel])
    const {
        dataGridState,
        setDataGridState,
    } = useSkyDataGridLocalStorage<SkyDataGridLocalStorage>(persistentKey, localStorageInitState)

    const onColumnVisibilityModelChange = useCallback((value: GridColumnVisibilityModel) => {
        const newState = {
            ...dataGridState,
            ...defaultSetStateConverter(value),
        }

        setDataGridState(newState)
    }, [
        setDataGridState,
        dataGridState,
    ])

    const localVisibilityModel = useMemo(() => {
        return dataGridState?.visibilityModel || initialVisibilityModel
    }, [
        dataGridState,
        initialVisibilityModel,
    ])

    return [
        localVisibilityModel,
        onColumnVisibilityModelChange,
    ]
}

export default usePersistedVisibleColumns
